<template>
  <div class="select-element">
    <div v-if="disabled" class="k-selected-type k-type text-size-18 ml-2">
      <span>{{ $t('options.typeSelected') }} "{{pollType}}"" </span> <br/>
      <span class="type-description"> <a @click="openExampleWindow" class="text-size-14 font-weight-normal"> {{  $t('options.viewExamples') }} </a> </span>
    </div>
    <div v-else class="k-selected-type k-type text-size-18 ml-2">
      {{ $t('options.typeTitle') }} <br />
      <div class="text-size-14 font-weight-normal">
        <span> {{ $t('options.typeSubtitle') }} </span>
        <span class="type-description"> <a @click="openExampleWindow"> {{  $t('options.viewExamples') }} </a> </span>
      </div>
    </div>
    <div class="select-tabs">
      <div
        @click="updateValue(1)"
        class="col type-tab text-center m-2"
        :class="activeClass(1)"
      >
        <div>
          <font-awesome-icon
            class="mr-1 ml-2 text-size-28"
            :icon="['fal', 'calendar-check']"
          />
        </div>
        <div class="type-option k-type">{{ $t('options.typePoll') }}</div>
      </div>

      <div
        @click="updateValue(3)"
        class="col type-tab text-center m-2"
        :class="activeClass(3)"
      >
        <div>
          <font-awesome-icon
            class="mr-1 ml-2 text-size-28"
            :icon="['fal', 'ballot-check']"
          />
        </div>
        <div class="type-option k-type">{{ $t('options.typeSurvey') }}</div>
      </div>

      <div
        @click="updateValue(2)"
        class="col type-tab text-center m-2"
        :class="activeClass(2)"
      >
        <div>
          <font-awesome-icon
            class="mr-1 ml-2 text-size-28"
            :icon="['fal', 'envelope-open-text']"
          />
        </div>
        <div class="type-option k-type">{{ $t('options.typeEvent') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number },
    active: { type: String },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
    
    };
  },

  computed: {

    pollType() {

      switch(this.value) {
      case 1:
        return this.$t('options.typePoll');

      case 2:
        return this.$t('options.typeEvent');

      case 3:
        return this.$t('options.typeSurvey');

      }
      return "unknown";
      }
    },

  methods: {
    updateValue: function (value) {
      if (this.disabled) {
        return;
      }
      this.$emit('input', value);
    },

    activeClass(tabId) {
      if (tabId != this.value) {

        let classes = "unselected";
        if( !this.disabled )  {
          classes = classes + " pointer";   // make the unselcted options clickable
        } else {
          classes = classes + " disabled";
        }
        return classes;

      }
      if (this.active) {
        return this.active;
      }
      return 'activeTab';
    },
    openExampleWindow() {
      let url = "https://kulibri.com/"+ this.$i18n.locale +"/examples-and-use-cases";
      window.open(url, '_blank').focus();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';

.type-tab {
  padding: 10px;
  color: $dark-grey;
}

.active {
  color: $primary;
  border: 1px solid $primary;
  background-color: white;
}

.unselected {
  border: 1px solid;
}

.unselected.pointer {
  color: $mid-grey;
}

.select-element {
  font-size: 16px;
  display: flex;
  flex-direction: column;
}

.select-tabs {
  font-size: 16px;
  display: flex;
  flex-direction: row;
}

.k-type {
  font-weight: 800;
}

.type-option {
  font-size: $standard;
}

.type-description {
  a {
    color: $primary !important;
    cursor: pointer;
  }
  a:hover {
    text-decoration: underline !important;
  }
}

@media (max-width: 640px) {
  .type-option {
    font-size: $small;
  }
}
</style>
